// extracted by mini-css-extract-plugin
module.exports = {"line":"Timeline_line__1Bge8","point":"Timeline_point__3kKLt","placeHolderShimmer":"Timeline_placeHolderShimmer__1GO9v","shimmer":"Timeline_shimmer__3EXJg"};